// combatpro/panels/monsters/studio/MonsterStudioCards.js
//
// Combat PRO - MonsterStudioCards (Stage 56: Editor Runtime Foundation).
//
// The repeatable card subsystem UI, ported from the legacy viStudioCardsHtml
// (battletracker.html 11122-11141). Renders the card list for one model field
// (traits / actions / bonusActions / reactions / legendaryActions / lairActions)
// as controlled inputs: a name field, an optional action-cost field (legendary
// only), a remove button, and a description textarea, plus an add button. All
// mutations are delegated to the editor runtime handlers (onAdd / onRemove /
// onUpdate from useMonsterStudioEditor); this component holds no state.
//
// No DOM, no persistence. No optional chaining. No em dash.

import React from 'react';

var CARD_LABELS = {
  traits: 'Trait',
  actions: 'Action',
  bonusActions: 'Bonus Action',
  reactions: 'Reaction',
  legendaryActions: 'Legendary Action',
  lairActions: 'Lair Action'
};

function MonsterStudioCards(props) {
  var listName = props.listName;
  var hasCost = props.hasCost;
  var cards = Array.isArray(props.cards) ? props.cards : [];
  var label = CARD_LABELS[listName] || 'Card';

  return (
    <>
      <div className="vi-st-cards" id={'vi-st-cards-' + listName}>
        {cards.map(function(c, idx) {
          return (
            <div className="vi-st-card" key={idx}>
              <div className="vi-st-card-row">
                <input
                  className="vi-st-card-name"
                  type="text"
                  placeholder={label + ' name'}
                  value={c.name || ''}
                  onChange={function(e) { props.onUpdate(listName, idx, 'name', e.target.value); }}
                />
                {hasCost ? (
                  <input
                    className="vi-st-card-cost"
                    type="number"
                    min="1"
                    title="Action cost"
                    value={c.cost || 1}
                    onChange={function(e) { props.onUpdate(listName, idx, 'cost', e.target.value); }}
                  />
                ) : null}
                <button
                  className="vi-st-card-del"
                  type="button"
                  title="Remove"
                  onClick={function() { props.onRemove(listName, idx); }}
                >
                  {'\u00d7'}
                </button>
              </div>
              <textarea
                className="vi-st-card-desc"
                rows="2"
                placeholder="Description"
                value={c.desc || ''}
                onChange={function(e) { props.onUpdate(listName, idx, 'desc', e.target.value); }}
              />
            </div>
          );
        })}
      </div>
      <button className="vi-st-add" type="button" onClick={function() { props.onAdd(listName); }}>
        {'\u2795'} Add {label}
      </button>
    </>
  );
}

export default MonsterStudioCards;
